export abstract class FilterBase {

  abstract GetFilter(inputValue: string): any;
}
